import { load } from 'cheerio';
import Provider from '@/enums/Provider';

export function extractMetaData(
    htmlSource: string,
    provider: Provider
): { metaTitle: string; metaDescription: string } {
    const $ = load(htmlSource);

    let metaTitle = '';
    let metaDescription = '';

    switch (provider) {
        case Provider.KBS:
            metaTitle = $('head > title').text() || '';
            metaDescription = $('meta[name="description"]').attr('content') || '';
            break;
        case Provider.IO:
            metaTitle = $('head > title').text() ||
                $('meta[property="og:title"]').attr('content') || '';
            metaDescription = $('meta[name="description"]').attr('content') ||
                $('meta[property="og:description"]').attr('content') || '';
            break;
        case Provider.ERS:
            metaTitle = $('head > title').text() || '';
            metaDescription = $('meta[name="description"]').attr('content') || '';
            break;
        default:
            break;
    }

    return { metaTitle, metaDescription };
}